import { Typography, Box, Button } from '@mui/material';
import CustodiansListTable from './Custodians/CustodiansListTable';
import Styles from './Styles/ListCustodiansStyles';
import CustodiansSearch from './Custodians/CustodiansSearch';
import useFetchCustodiansSearchResult from '../../hooks/Locations/useFetchCustodiansSearchResult';
import { cardContainer } from '../../assets/styles/appStyles';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import useAuth from '../../hooks/context/useAuth';
import { appActions } from '../../settings/appConfig';

export default function CustodiansList() {
  const { isAuthorized } = useAuth();
  const { data, pageChanged, searchChanged, isLoading } = useFetchCustodiansSearchResult();
  const [pageNo, setPageNo] = useState(0);
  const [showNewMapScreen, setShowNewMapScreen] = useState(false);
  const navigate = useNavigate();

  const onSearchChanged = (searchText?: string, stateId?: string) => {
    setPageNo(0);
    searchChanged(searchText, stateId);
  }
  if (showNewMapScreen) {
    navigate("/entity/add");
  }

  return (
    <Box sx={cardContainer} p={2}>
      <Box sx={{ ...Styles.cardStyles, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={Styles.headerTitleStyles}>Entities Management</Typography>
        {isAuthorized(appActions.addEntity) && <Button
          variant="outlined"
          size="medium"
          onClick={() => setShowNewMapScreen(true)}
          sx={{
            backgroundColor: '#F97316',
            color: 'white',
            borderRadius: '8px',
            textTransform: 'none',
            padding: '8px 20px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: '#D25B10',
              transform: "translateY(-2px)",
              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
            },
          }}
        >
          Add New Entity
        </Button>}
      </Box>
      <CustodiansSearch onSearchChanged={onSearchChanged}
        showStatesFiltration={true} /><CustodiansListTable
        custodians={data.entities}
        count={data.count}
        onPageChanged={pageChanged}
        isLoading={isLoading}
        unmountCollapsedOnExit={true}
        pageNo={pageNo}
        setPageNo={setPageNo}
        usePagination={true}
        showNoRecordsFoundMessage={true} />
    </Box>
  );
}
